<div class="logo">
     <img src="assets/images/Picture1.png">
  </div>